import type { Option } from '@last/core-ui/paprika/components/dropdown/types'

import { t } from '@/i18n'

export type TableStates = 'empty' | 'occupied' | 'toPay' | 'reserved'

type MenuValues =
  | 'printTicket'
  | 'moveAccount'
  | 'mergeTabs'
  | 'swapTables'
  | 'closeTable'
  | 'reservations'
  | 'moveReservation'

const menuItems: Record<MenuValues, Option> = {
  ['printTicket']: {
    icon: 'printer',
    label: t('floorplan.print-ticket'),
    value: 'printTicket'
  },
  ['moveAccount']: {
    icon: 'double-arrow-sides',
    label: t('floorplan.move-account'),
    value: 'moveAccount'
  },
  ['swapTables']: {
    icon: 'refresh',
    label: t('floorplan.swap-tables'),
    value: 'swapTables'
  },
  ['mergeTabs']: {
    icon: 'double-arrow-inside',
    label: t('floorplan.merge-tabs'),
    value: 'mergeTabs'
  },
  ['closeTable']: {
    icon: 'close',
    label: t('floorplan.close-table'),
    value: 'closeTable'
  },
  ['reservations']: {
    icon: 'calendar',
    label: t('floorplan.reservations'),
    value: 'reservations'
  },
  ['moveReservation']: {
    icon: 'double-arrow-sides',
    label: t('floorplan.move-reservations'),
    value: 'moveReservation'
  }
}

export const mapTableStateToMenuItems: Record<TableStates, Option[]> = {
  ['empty']: [],
  ['occupied']: [
    menuItems['printTicket'],
    menuItems['moveAccount'],
    menuItems['mergeTabs'],
    menuItems['swapTables'],
    menuItems['closeTable']
  ],
  ['reserved']: [menuItems['moveReservation']],
  ['toPay']: [
    menuItems['printTicket'],
    menuItems['moveAccount'],
    menuItems['swapTables'],
    menuItems['mergeTabs'],
    menuItems['closeTable']
  ]
}
